import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useFrequencyType, FrequencyType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<FrequencyType>
      useData={useFrequencyType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
